import { useMemo } from 'react';

import { Cta } from '@/typings/generic';

const useIsIconValid = (icon: Cta['icon'] | React.ReactNode) => {
	const isValid = useMemo(() => {
		if (
			typeof icon === 'string' &&
			icon?.toLowerCase() !== 'none' &&
			Boolean(icon)
		) {
			return true;
		}
		return false;
	}, [icon]);

	return isValid;
};

export default useIsIconValid;
